export const VALUE = 'value';
export const ERROR = 'error';
export const REQUIRED_FIELD_ERROR = ' ';

function is_bool(value) {
  return typeof value === 'boolean';
}

/**
 * Determines a value if it's an object
 *
 * @param {object} value
 */
export function isObject(value) {
  return typeof value === 'object' && value !== null;
}

/**
 *
 * @param {string} value
 * @param {boolean} isRequired
 */
export function isRequired(value, isRequired) {
  if (!value && isRequired) return REQUIRED_FIELD_ERROR;
  return '';
}

export function getPropValues(stateSchema, prop) {
  return Object.keys(stateSchema).reduce((field, key) => {
    field[key] = is_bool(prop) ? prop : stateSchema[key][prop];

    return field;
  }, {});
}
